// Libs
import classNames from 'classnames/bind';
import { Grid2, IconButton } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseInput, BaseInputPhone } from '~/components/common';
// Others
import { IFormCustomer } from '~/utils/interface/customer';
// Styles, images, icons
import styles from './CustomerAdditionalContact.module.scss';
import { icons } from '~/assets';

type Props = {
  index: number;
  onRemoveItem: (index: number) => void;
};

const cx = classNames.bind(styles);

const CustomerAdditionalContact = (props: Props) => {
  //#region Destructuring Props
  const { index, onRemoveItem } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/customer']);

  const {
    control,
    formState: { errors },
  } = useFormContext<IFormCustomer>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2
      component={'div'}
      id='customerAdditionalContactComponent'
      className={cx('container')}
      container
      rowSpacing={'12px'}
      columnSpacing={'12px'}
    >
      <Grid2 size='grow'>
        <Controller
          name={`customerContacts.${index}.name`}
          control={control}
          render={({ field: { value, onChange } }) => (
            <BaseInput
              label={t('field_name_label')}
              value={value}
              onChange={onChange}
              errorMessage={errors?.customerContacts?.[index]?.name?.message}
            />
          )}
        />
      </Grid2>

      <Grid2 size='grow'>
        <Controller
          name={`customerContacts.${index}.email`}
          control={control}
          render={({ field: { value, onChange } }) => (
            <BaseInput
              label={t('field_email_label')}
              value={value}
              onChange={onChange}
              errorMessage={errors?.customerContacts?.[index]?.email?.message}
            />
          )}
        />
      </Grid2>

      <Grid2 size='grow'>
        <Controller
          name={`customerContacts.${index}.phoneNumber`}
          control={control}
          render={({ field: { value, onChange } }) => (
            <BaseInputPhone
              label={t('field_phone_number_label')}
              value={value}
              onChange={onChange}
              errorMessage={errors?.customerContacts?.[index]?.phoneNumber?.message}
            />
          )}
        />
      </Grid2>

      <Grid2 size={'auto'}>
        <IconButton className={cx('closeField')} onClick={() => onRemoveItem(index)}>
          <img src={icons.commonIconClose} alt={t('common_alt_img', { ns: 'common/base' })} />
        </IconButton>
      </Grid2>
    </Grid2>
  );
};

export default CustomerAdditionalContact;
